import React from 'react';
import { t } from 'translate/i18n';

import * as S from './HeaderStyled';

const Header: React.FC = () => {
  const translationString = 'components.nft.header';

  return (
    <S.Container>
      <S.Title>{t(`${translationString}.title`)}</S.Title>
      <S.Description>{t(`${translationString}.description`)}</S.Description>
    </S.Container>
  );
};

export default Header;
